import React, { useState, useEffect, useRef } from "react";
import Box from "@material-ui/core/Box";
import MiniProgress from "./MiniProgress";
import { withStyles } from "@material-ui/core/styles";

const Container = withStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        width: "400px",
        padding: "0px 5px 0px 5px",

        [theme.breakpoints.down(361)]: {
            width: "300px",
        },
        [theme.breakpoints.between(361, 430)]: {
            width: "350px",
        },
    },
}))(Box);
const ItemContainer = withStyles((theme) => ({
    root: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",

    },
}))(Box);
const TextContainer = withStyles((theme) => ({
    root: {
        display: "flex",
        width: "fit-content",
        margin: "11px 0px 11px 0px",
        ...theme.typography.body2,
        fontSize: "14px",
        fontWeight: 600,

        [theme.breakpoints.down(361)]: {
            fontSize: "13px",
        },
    },
}))(Box);
const ProgressContainer = withStyles((theme) => ({
    root: {
        display: "flex",
        width: "165px",
        position: "relative",

        [theme.breakpoints.down(361)]: {
            width: "105px",
        },
        [theme.breakpoints.between(361, 430)]: {
            width: "140px",
        },
    },
}))(Box);

const SearchingLenders = (props) => {
    const {
        searchingForList,
        index,
        onComplete,
    } = props;

    const numItems = searchingForList.length;
    const [completedCount, setCompletedCount] = useState(0);

    const runOnComplete = useRef(async () => {
        await onComplete(index);
    });

    useEffect(() => {
        if (completedCount === numItems) {
            runOnComplete.current();
        }
    }, [completedCount, numItems]);

    const incrementCompletedCount = () => setCompletedCount((prevCount) => prevCount += 1);

    const renderItems = () => {
        let time = 1;
        return searchingForList.map((text, i) => {
            time += (i*0.80);
            return (
                <ItemContainer key={i}>
                    <TextContainer>
                        {text}
                    </TextContainer>
                    <ProgressContainer>
                        <MiniProgress
                            delay={time}
                            incrementCompletedCount={incrementCompletedCount}
                        />
                    </ProgressContainer>
                </ItemContainer>
            );
        });
    };

    return (
        <Container>
            {renderItems()}
        </Container>
    );
};

export default SearchingLenders;